import type { ListTypeListItem } from '@/types/list-type';
import { TOGGLE_TYPE_ALL_CATEGORY_ID } from '@/types/toggle-type';

const sortBySortOrderDesc = (a: ListTypeListItem, b: ListTypeListItem) => (b.sortOrder ?? 0) - (a.sortOrder ?? 0);

export const getToggleTypeItemsByCategory = (
    categoryId: number | string,
    toggleTypeItems: ListTypeListItem[],
    categoryIds: string[] = []
) => {
    if (categoryId === TOGGLE_TYPE_ALL_CATEGORY_ID) {
        if (!categoryIds.length) {
            return [...toggleTypeItems].sort(sortBySortOrderDesc);
        }

        return categoryIds.flatMap((id) =>
            toggleTypeItems.filter((item) => String(item.categoryId) === String(id)).sort(sortBySortOrderDesc)
        );
    }

    return toggleTypeItems.filter((item) => String(item.categoryId) === String(categoryId)).sort(sortBySortOrderDesc);
};
